import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import css from "./ConfirmationPage.css";
import TextHeader from "./TextHeader";
import StyledButton from 'common/StyledButton';
import {DEFAULT_TIMEOUT} from "../utils/kiosk";
import { landingPageForVirtualKiosk, showStudentDashboard } from 'utils/kiosk';
import { getWord } from 'utils/tenant';

function ConfirmationPage(props) {
  const timeout = props.virtualSignInEnabled && props.isProspectiveStudent
      ? 2 * 60 * 1000
      : (props.timeout || DEFAULT_TIMEOUT);

  useEffect(() => {
    if (props.virtualSignInEnabled && !props.isProspectiveStudent) return;
    const timeoutId = setTimeout(props.onTimeout, timeout);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className={css['content']} aria-live="assertive">
      <TextHeader
        upperText={props.upperText}
        lowerText={props.lowerText}
      />
      <img src={props.imageUrl}  aria-hidden="true"
           className={css['image']}/>
      {props.children}
      { !props.isProspectiveStudent && props.virtualSignInEnabled &&
          <StyledButton
            className={css['primary-button']}
            onClick={() => window.location = landingPageForVirtualKiosk()}>
            {showStudentDashboard() ? `Go to Dashboard` : `Go to ${getWord("successNetwork", false)}`}
          </StyledButton>
      }
    </div>
  );
}

ConfirmationPage.propTypes = {
  lowerText: PropTypes.string,
  upperText: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  timeout: PropTypes.number,
  onTimeout: PropTypes.func.isRequired,
  isProspectiveStudent: PropTypes.bool.isRequired,
  virtualSignInEnabled: PropTypes.bool.isRequired
};

export default ConfirmationPage;
